import React, { useState } from 'react';
import { MonitoredAudioUrl } from '@round/api';
import cardStyles from './MonitoringCard.module.css';
import cn from 'classnames';
import styles from './ReliabilityStatus.module.css';
import { Popover } from '@round/ui-kit';
import Card from '../../../../../../../ui/Card/Card';
import { ReactComponent as QuestionMarkIcon } from '../../../../../../../assets/QuestionMark.svg';

type Props = {
    monitoredAudio: MonitoredAudioUrl;
};

const ReliabilityStatus = ({ monitoredAudio }: Props) => {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    return (
        <>
            <div ref={setAnchor} className={cn(cardStyles.card, styles.card)}>
                <div className={styles.iconContainer}>
                    <QuestionMarkIcon className={styles.icon} />
                </div>

                <p
                    className={cn(cardStyles.title, {
                        [styles.positive]: monitoredAudio.is_enabled && monitoredAudio.is_active,
                        [styles.negative]: !monitoredAudio.is_active,
                        [styles.warning]: monitoredAudio.is_active && !monitoredAudio.is_enabled,
                    })}
                >
                    {!monitoredAudio.is_active
                        ? 'No longer available'
                        : monitoredAudio.is_active && !monitoredAudio.is_enabled
                          ? 'Potential issues'
                          : 'No issues'}
                </p>
                <p className={cardStyles.subtitle}>Reliability Status</p>
            </div>

            <Popover
                anchorElement={anchor}
                showOn="hover"
                options={{ placement: 'bottom-start', modifiers: [{ name: 'offset', options: { offset: [0, 5] } }] }}
            >
                <Card className={styles.tooltip}>
                    <dl className={styles.statusDescriptions}>
                        <div className={styles.statusDescription}>
                            <dt className={styles.positive}>No issues</dt>
                            <dd>Audio data is being retrieved daily without any issues. </dd>
                        </div>

                        <div className={styles.statusDescription}>
                            <dt className={styles.warning}>Potential issues</dt>
                            <dd>Data is not being retrieved daily, possible the audio has been removed.</dd>
                        </div>

                        <div className={styles.statusDescription}>
                            <dt className={styles.negative}>No longer available</dt>
                            <dd>The audio is no longer available on TikTok.</dd>
                        </div>
                    </dl>
                </Card>
            </Popover>
        </>
    );
};

export default ReliabilityStatus;
